import React from 'react';
import ContentLoader from 'react-content-loader';

type HeightLoaderProps = {
  height: number;
  className?: string;
};

const HeightLoader = ({ height, className }: HeightLoaderProps) => (
  <ContentLoader
    className={className || 'w-full'}
    speed={2}
    width="100%"
    height={height}
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <rect x="0" y="0" width="100%" height={height} rx="10" ry="10" />
  </ContentLoader>
);

export default HeightLoader;
